import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
      // gcTime: 0, // Helps to debug without cache IF gcTime per request isn't specified ! @Dev
      // staleTime: 0, // Helps to debug without cache IF staleTime per request isn't specified ! @Dev
    },
  },
});
